import React from 'react';
import CustomPopup from '../CustomPopup';
import { IPPSubHeading } from '../../../library/Heading/Heading';
import InputField from '../../../library/inputField/inputField';
import Button from '../../../library/Button/button';
import IRepoOwner from '../../../utils/RepoOwner/RepoOwner.interface';

interface EditOwnerPopupProps {
  show: boolean;
  onClose: () => void;
  formData: IRepoOwner;
  originalData: IRepoOwner;
  setFormData: (data: IRepoOwner) => void;
  onSubmit: () => Promise<void>;
  submitting: boolean;
}

const EditOwnerPopup: React.FC<EditOwnerPopupProps> = ({
  show,
  onClose,
  formData,
  originalData,
  setFormData,
  onSubmit,
  submitting
}) => {
  const hasChanges = formData.repoOwnerName.trim() !== originalData.repoOwnerName.trim() ||
    (formData.repoOwnerInfo ?? '').trim() !== (originalData.repoOwnerInfo ?? '').trim();

  return (
  <CustomPopup onClose={onClose} show={show} width="w-41%">
    <div className="px-2 py-2">
      <IPPSubHeading headerText="Edit Owner" className="text-lg font-medium mb-4" />
      <div className="flex flex-col gap-3">
        <div>
          <label className="text-sm font-medium text-black">Owner Name</label>
          <InputField
            id="edit-owner-name"
            type="text"
            className="w-full rounded-lg px-3 py-2 border border-light-gray mt-1"
            value={formData.repoOwnerName}
            onChange={(e) => setFormData({ ...formData, repoOwnerName: e.target.value })}
            placeholder="Owner name"
          />
        </div>
        <div>
          <label className="text-sm font-medium text-black">Info</label>
          <InputField
            id="edit-owner-info"
            type="text"
            className="w-full rounded-lg px-3 py-2 border border-light-gray mt-1"
            value={formData.repoOwnerInfo ?? ''}
            onChange={(e) => setFormData({ ...formData, repoOwnerInfo: e.target.value })}
            placeholder="Owner info"
          />
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <Button
          className={`text-[#fff] text-base rounded-lg py-2 px-6 ${hasChanges ? 'cursor-pointer bg-black' : 'cursor-not-allowed bg-black opacity-60'}`}
          buttonText="Update"
          onclick={onSubmit}
          loading={submitting}
          disabled={submitting || !hasChanges}
        />
      </div>
    </div>
  </CustomPopup>
  );
};

export default React.memo(EditOwnerPopup);
